import React, { useEffect, useReducer } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { Pill } from '@scoir/pills'
import { get, isUndefined } from 'lodash'
import hash from 'object-hash'
import PropTypes from 'prop-types'

import api from 'common/api'
import useScid from 'common/use-scid'
import LoadingBubbles from 'components/LoadingBubbles'

import reducer, { types } from './reducer'

const KNOWN_SEGMENTS = {}
const INITIAL_STATE = {
  isLoading: false,
  hasError: false,
  numRecipients: 0,
}

const useStyles = makeStyles({
  loadingBubbles: {
    width: '30px',
  },
})

const ReachEstimate = ({ loadEstimate, segment }) => {
  const classes = useStyles()
  const scid = useScid()
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE)
  const { isLoading, hasError, numRecipients } = state
  useEffect(() => {
    const segmentHash = hash(segment)
    if (!isUndefined(KNOWN_SEGMENTS[segmentHash])) {
      dispatch({
        type: types.CACHE_SUCCESS,
        payload: KNOWN_SEGMENTS[segmentHash],
      })
    } else {
      dispatch({
        type: types.FETCH_START,
      })
      if (loadEstimate) {
        const timer = setTimeout(() => {
          api
            .post(`/api/colleges/${scid}/segment/size`, segment)
            .then((res) => {
              dispatch({
                type: types.FETCH_SUCCESS,
                payload: res,
              })
              KNOWN_SEGMENTS[segmentHash] = get(res, 'Size', 0)
            })
            .catch(() =>
              dispatch({
                type: types.FETCH_FAILURE,
              }),
            )
        }, 2000)
        return () => clearTimeout(timer)
      }
    }
  }, [loadEstimate, segment, scid])

  if (isLoading) {
    return (
      <Pill color="info">
        <LoadingBubbles
          altText="Loading Estimate"
          className={classes.loadingBubbles}
        />
      </Pill>
    )
  } else if (hasError) {
    return <Pill color="error">There was an error loading estimate</Pill>
  } else {
    return (
      <Pill color={numRecipients === 0 ? 'error' : 'info'}>
        {`${numRecipients} Estimated Recipient${numRecipients === 1 ? '' : 's'}`}
      </Pill>
    )
  }
}
ReachEstimate.propTypes = {
  segment: PropTypes.object.isRequired,
  loadEstimate: PropTypes.bool.isRequired,
}

export default ReachEstimate
